import request from '@/utils/request'
import qs from 'qs'

export function getGeneralListReport(query) {
  return request({
    url: '/report-service/v1/general-manage-report/list',
    method: 'get',
    params: query,
    paramsSerializer: query =>
      qs.stringify(query, {
        arrayFormat: 'repeat',
        encode: false
      })
  })
}
export function getGeneralListReportExcel(query) {
  return request({
    url: '/report-service/v1/general-manage-report/list-export-excel',
    method: 'get',
    params: query,
    paramsSerializer: query =>
      qs.stringify(query, {
        arrayFormat: 'repeat',
        encode: false
      }),
    responseType: 'blob'
  })
}
export function getForecastListReport(query) {
  return request({
    url: '/report-service/v1/general-manage-report/listForecast',
    method: 'get',
    params: query,
    paramsSerializer: query =>
      qs.stringify(query, {
        arrayFormat: 'repeat',
        encode: false
      })
  })
}
export function getForecastListReportExcel(query) {
  return request({
    url: '/report-service/v1/general-manage-report/listForecast-excel',
    method: 'get',
    params: query,
    paramsSerializer: query =>
      qs.stringify(query, {
        arrayFormat: 'repeat',
        encode: false
      }),
    responseType: 'blob'
  })
}
